import { withInstall } from '@bigin/utils'
import Drawer from './src/drawer.vue'

export const BDrawer = withInstall(Drawer)
export default BDrawer

export * from './src/drawer'
